import { useFirestoreGeneralOrderBy } from '../../../firebase/useFirestore';
import countActiveOptions from '../../../helpers/intakeForms/countActiveOptions';

const SupportFormOptionsCount = ({fieldId}) => {

const options = useFirestoreGeneralOrderBy(
    "MultipleQuestionOptions",
    "Field",
    fieldId,
    "Position",
    "asc"
    );


  return (
    <>{countActiveOptions(options)}</>
  )
}

export default SupportFormOptionsCount